import React from 'react';
import PrimaryButton from './StyledColorComponents/PrimaryButton';
import styles from './index.module.scss';
import BorderedSecondaryButton from './StyledColorComponents/BorderedSecondaryButton';
import OutlinedSecondaryButton from './StyledColorComponents/OutlinedSecondaryButton';
import SolidSecondaryButton from './StyledColorComponents/SolidSecondaryButton';
import SquareButton from './StyledColorComponents/SquareButton';

type ButtonsPreviewProps = {
  ButtonsPreviewProps: {
    primaryBtnGradientStart: string;
    primaryBtnGradientEnd: string;
    primaryBtnTxt: string;
    secondaryBtnBg: string;
    secondaryBtnTxt: string;
  };
};

const ButtonsPreview = ({
  ButtonsPreviewProps: {
    primaryBtnGradientStart,
    primaryBtnGradientEnd,
    primaryBtnTxt,
    secondaryBtnBg,
    secondaryBtnTxt,
  },
}: ButtonsPreviewProps) => {
  return (
    <div className={styles.btnsContainer}>
      <h3>按鈕預覽：</h3>
      <PrimaryButton
        gradientStart={primaryBtnGradientStart}
        gradientEnd={primaryBtnGradientEnd}
        spanColor={primaryBtnTxt}
      />
      <BorderedSecondaryButton
        gradientStart={primaryBtnGradientStart}
        gradientEnd={primaryBtnGradientEnd}
      />
      <OutlinedSecondaryButton
        secondaryBtnBg={secondaryBtnBg}
        secondaryBtnTxt={secondaryBtnTxt}
      />
      <SolidSecondaryButton
        secondaryBtnBg={secondaryBtnBg}
        secondaryBtnTxt={secondaryBtnTxt}
      />
      <SquareButton
        secondaryBtnBg={secondaryBtnBg}
        secondaryBtnTxt={secondaryBtnTxt}
      />
    </div>
  );
};

export default ButtonsPreview;
